<app-global-info
  icon="mdi-alert-circle-outline"
  [title]="'mobile-upload.expired-error.title' | translate"
  [description]="'mobile-upload.expired-error.text' | translate"
></app-global-info>
